import { useState, type PropsWithChildren } from 'react';

import type { Meta, StoryFn } from '@storybook/react';

import { FeedbackBar } from 'components/FeedbackBar';
import { Button } from 'components/Buttons';
import { Repeater } from 'components/Repeater';
import { ButtonGroup } from 'components/ButtonGroup';

const codeString = '<FeedbackBar>{children}</FeedbackBar>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/FeedbackBar',
  component: FeedbackBar,
  parameters: {
    inspectComponent: FeedbackBar,
    codeString: codeString,
  },
} as Meta<PropsWithChildren>;

const Template: StoryFn<PropsWithChildren> = (args) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Repeater>
      <ButtonGroup>
        <Button variant="primary" onClick={() => setIsOpen(true)}>
          Click to open FeedbackBar
        </Button>
        <Button variant="primary" onClick={() => setIsOpen(false)}>
          Click to reset animation for FeedbackBar
        </Button>
      </ButtonGroup>
      {isOpen && <FeedbackBar {...args} />}
    </Repeater>
  );
};

export const FeedbackBarExample = Template.bind({});
FeedbackBarExample.args = {
  children: 'This is example feedback',
};
